export default __webpack_public_path__ + "static/media/filter-gray.4ce0feb7.svg";